// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__37i0r","wrapper-nopadding":"wrapper-nopadding__2vdJg","loading":"loading__2PyY4","error":"error__16uM2","table-loading":"table-loading__2wbwE","empty-val":"empty-val__2VzcJ","panelheader-tools":"panelheader-tools__jGJA2","propsPanels":"propsPanels__2Sv9L","new":"new__Ufvh2","marginLm":"marginLm__136Nm","marginRm":"marginRm__Hb4k3","fullWidth":"fullWidth__3_rxo","fullHeight":"fullHeight__3Qq20","noData":"noData__Jco29","flushcp":"flushcp__tr2xm","errorBlock":"errorBlock__3r6Kw","noauth":"noauth__30zcQ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewayProps/styles.scss
// module id = 2267
// module chunks = 1